import { SprintActivityGameOptions } from '../types/Sprint'

/**
 * Game options passed to the Unity game and stored on sprint activities.
 * Only slot (customSlotLength) is sent; display buffer is UI-only and not included here.
 */
export const DEFAULT_GAME_SLOT_LENGTH_SECONDS = 15 * 60
export const LEGACY_DEFAULT_GAME_SLOT_LENGTH_SECONDS = 20 * 60 // NOT LEGACY-> this is visually for FE
export const FIRST_GAME_INTRO_MINUTES = 15
/** Default display buffer (minutes) when not set; used for slot+buffer display in BO and facilitator. */
export const DEFAULT_DISPLAY_BUFFER_MINUTES = 5

export const SPRINT_ACTIVITY_GAME_OPTION_KEYS = [
  'numberOfLoops',
  'customSlotLength',
  'minTimeLeftToAllowRestart',
  'finalReflectionTimeOut'
] as const

type SprintActivityGameOptionKey = (typeof SPRINT_ACTIVITY_GAME_OPTION_KEYS)[number]

const sanitizeOptionalNumber = (value: unknown): number | undefined => {
  if (value == null) {
    return undefined
  }

  if (typeof value === 'string' && value.trim() === '') {
    return undefined
  }

  const parsed = typeof value === 'number' ? value : Number(value)

  return Number.isFinite(parsed) ? parsed : undefined
}

export const sanitizeSprintActivityGameOptions = (
  value?: Partial<Record<SprintActivityGameOptionKey, unknown>>
): SprintActivityGameOptions => {
  const sanitized: SprintActivityGameOptions = {}

  for (const key of SPRINT_ACTIVITY_GAME_OPTION_KEYS) {
    const rawValue = sanitizeOptionalNumber(value?.[key])
    const normalizedValue =
      key === 'customSlotLength' && rawValue === LEGACY_DEFAULT_GAME_SLOT_LENGTH_SECONDS
        ? DEFAULT_GAME_SLOT_LENGTH_SECONDS
        : rawValue

    if (normalizedValue !== undefined) {
      sanitized[key] = normalizedValue
    }
  }

  return sanitized
}
